<template>
  <div v-if="value" class="article-metadata-content">
    <span v-if="label" class="article-metadata-info">
      {{ label }}
    </span>
    <span>
      {{ value }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    }
  }
};
</script>
